// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1NgCW","formContainer":"style_formContainer__bJTD_","logo":"style_logo__3QHza","form":"style_form__3Gqaq","kalera":"style_kalera__3rvCY"};